import { Pipe, PipeTransform } from '@angular/core';
import * as _ from "lodash";
@Pipe({
  name: 'dataFilter'
})
export class DataFilterPipe implements PipeTransform {


  transform(array: any[], query: string): any {
    if (query) {
      return _.filter(array, row => row.name.indexOf(query) > -1);
    }
    return array;
  }

}



// WEBPACK FOOTER //
// ./src/app/data-filter.pipe.ts